import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

import actions from './actions'
import getters from './getters'
// import types from '/src/store/types'

// global modules
import menu from '/src/store/modules/menu'
import cart from '/src/store/modules/cart'
import content from '/src/store/modules/content'
import gtm from '/src/store/modules/gtm'
import marketing from '/src/store/modules/marketing'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

const state = {
}

const mutations = {
}

const inTwoHours = 1 / 12

const store = new Vuex.Store({
  strict: debug,
  actions,
  getters,
  state,
  mutations,
  modules: {
    menu,
    cart,
    content,
    gtm,
    marketing
  },
  plugins: [createPersistedState({
    // storage: window.sessionStorage,
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: inTwoHours }),
      removeItem: key => Cookies.remove(key)
    },
    paths: ['cart']
  })]
})

if (process.env.NODE_ENV === 'development') {
  window.store = store
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js